module.exports = __webpack_public_path__ + "static/media/logo.99c8f204.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 117
// module chunks = 0